export default "__VITE_ASSET__zpBVMV4h__"